import React from "react";

export const  IconWarningExclamation = ({className="",width="",height=""}) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        className={className}
        width={width} fill="none" 
        viewBox="0 0 14 14">
        <path d="M7.00001 13.6666C3.32001 13.6666 0.333344 10.68 0.333344 6.99996C0.333344 3.31996 3.32001 0.333294 7.00001 0.333294C10.68 0.333294 13.6667 3.31996 13.6667 6.99996C13.6667 10.68 10.68 13.6666 7.00001 13.6666ZM7.66668 3.66663H6.33334V7.66663H7.66668V3.66663ZM7.66668 8.99996H6.33334V10.3333H7.66668V8.99996Z" fill="#E29700"/>
</svg>
    );
  }






